<template lang="pug">
.v-field-contacts.field-contacts
	.field-contacts__cards(v-if="field.cards" )
		.field-contacts__card(v-for="(card, index) in field.cards" :key="index")
			img.field-contacts__card-image(
				v-if="card.image"
				:src="card.image?.src"
				:alt="card.image?.alt")
			.field-contacts__card-info(v-if="card.info" )
				.field-contacts__card-name(v-if="card.info.name" ) {{ card.info.name }}
				.field-contacts__card-position(v-if="card.info.position" ) {{ card.info.position }}
				.field-contacts__card-email(v-if="card.info.email" ) {{ card.info.email }}
				.field-contacts__card-tel(v-if="card.info.tel" ) {{ card.info.tel }}
				.field-contacts__card-actions(v-if="card.buttons && isXs" )
					button.field-contacts__card-action(v-for="(button, index) in card.buttons"
						:key="index"
						:class="button?.className || ''"
						:title="button?.title || ''"
						type="button"
						@click="buttonEvent(card.id,button.event)")
						v-svg-icon.field-contacts__card-icon(v-if="button.icon" :icon="button.icon")
			.field-contacts__card-actions(v-if="card.buttons && !isXs" )
				button.field-contacts__card-action(v-for="(button, index) in card.buttons"
						:key="index"
						:class="button?.className || ''"
						:title="button?.title || ''"
						type="button"
						@click="buttonEvent(card.id,button.event)")
					v-svg-icon.field-contacts__card-icon(v-if="button.icon" :icon="button.icon")

	template(v-if="field.buttons" )
		button.field-contacts__add(
			v-for="(button, index) in field.buttons"
			type="button"
			@click="openModal"
			:class="button.class"
			:id="uniqueId"
			:key="index"
			:disabled="button.disabled")
			| {{ button.text }}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import controller from '../scripts/controller/controller.js';
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value',
	],

	data() {
		return {
			data: null,
			localValue: null,
			uniqueId: uniqueId('field-'),
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		dataSet(data) {
			if(data.updateForm) {
				window.modalController.closeAll();
				controller.updateForm();
			}

			if(data.modalAddContact) {
				controller.openModal({
					...data.modalAddContact
				});
			}

			if(data.type === 'edit-user') {
				controller.openModal({
					component: {
						name: 'v-add-contact-form',
						props: {
							dataSource: data,
						}
					}
				});
			}
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		buttonEvent(id, event) {
			switch (event) {
				case "edit": {
					this.dataLoad({
						url: this.field.remote,
						delay: true,

						data: {
							id,
							event,
							action: 'get_modal',
						}
					})
					break
				}
				case "remove": {
					this.requestRemove(id, event)
					break
				}
			}
		},

		openModal() {
			controller.openModal({
				...this.field.modalAddContact
			});
		},

		requestRemove(id, event) {
			if(this.field.modalConfirmRemove) {
				controller.openModal({
					component: {
						...this.field.modalConfirmRemove,
						listeners: {
							'confirm': async () => {
								await this.dataLoad({
									url: this.field.remote,
									delay: true,
									data: {
										id,
										event,
									}
								})
							},
						}
					}
				});
			} else {
				this.dataLoad({
					url: this.field.remote,
					delay: true,
					data: {
						id,
						event,
					}
				})
			}
		},

	},

};
</script>